var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineDocumentFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.03 15.82A2.074 2.074 0 0 1 4.96 14v-3.57c0-.26-.17-.7-.38-.95L2.06 6.83c-.47-.46-.81-1.26-.81-1.87V3.41c0-1.21.92-2.17 2.1-2.17h8.9c1.16 0 2.1.94 2.1 2.1v1.48c0 .78-.45 1.64-.89 2.08l-2.93 2.59c-.23.19-.42.65-.42.99v2.9c0 .69-.42 1.46-.97 1.79l-.92.6c-.36.22-.75.33-1.14.33-.36 0-.72-.09-1.05-.28zM2.75 3.42v1.55c0 .17.17.6.39.82L5.72 8.5c.38.47.75 1.24.75 1.93V14c0 .3.19.45.31.51.16.09.42.14.64 0l.93-.6c.12-.07.26-.35.26-.52v-2.9c0-.79.39-1.66.94-2.13l2.88-2.55c.18-.18.42-.67.42-.99V3.34c0-.33-.27-.6-.6-.6h-8.9v.01c-.34 0-.6.29-.6.67z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75v-3c0-.41.34-.75.75-.75s.75.34.75.75v3c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-2.9-.68-4.58-2.21-5.45-.16-.09-.69-.33-2.21-.57a.742.742 0 0 1-.62-.86c.07-.41.46-.69.86-.62 1.31.21 2.2.45 2.71.74 2.02 1.15 2.97 3.3 2.97 6.76v6c0 5.43-2.32 7.75-7.75 7.75H9z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h5c.41 0 .75.34.75.75s-.34.75-.75.75h-5zM11 17.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h7c.41 0 .75.34.75.75s-.34.75-.75.75h-7z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineDocumentFilter);
export default __webpack_public_path__ + "static/media/vuesax-outline-document-filter.ce345e309d01eb6b26238a9d277ae5ba.svg";
export { ForwardRef as ReactComponent };